import { render, staticRenderFns } from "./GeneralField.vue?vue&type=template&id=2cc3315c&scoped=true&"
import script from "./GeneralField.vue?vue&type=script&lang=ts&"
export * from "./GeneralField.vue?vue&type=script&lang=ts&"
import style0 from "./GeneralField.vue?vue&type=style&index=0&id=2cc3315c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc3315c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VCombobox,VSelect,VSpacer,VTextField,VTextarea})
